import { OrderItem, Promotion } from 'kiolyn-api';
import { cloneDeep } from 'lodash';
import checkIsPromotionItem from './CheckIsPromotionItem';
import newId from './NewId';

export default function applyBuyStGetStPromotion(
  availablePromotions: Promotion[],
  orderItems: OrderItem[]
): void {
  const promotions = availablePromotions.filter(
    p => p.promotion_type === 'buystgetst'
  );
  for (const promotion of promotions) {
    if (
      promotion.get_quantity === undefined ||
      promotion.get_items === undefined
    ) {
      continue;
    }

    // find item in the order if it is one of get_items of promotion
    // to check quantity until the the quantity equal to get_quantity of promotion
    const matchItems: OrderItem[] = [];
    let matchQuantity = 0;
    let appliedFlag = false;
    const sortedOrderItems = [...orderItems].sort(
      (a, b) => (a.count ?? 0) - (b.count ?? 0)
    );
    for (const orderItem of sortedOrderItems) {
      if (orderItem.IsPromotion) {
        continue;
      }

      const index = promotion.get_items.findIndex(it =>
        checkIsPromotionItem(orderItem, it)
      );
      if (index >= 0) {
        const itemQuantity = orderItem.count ?? 0;
        // find the match count item first
        if (itemQuantity === promotion.get_quantity) {
          orderItem.IsPromotion = true;
          orderItem.promotion_id = promotion.id;
          orderItem.promotion_name = promotion.name;
          promotion.applied_count = (promotion.applied_count ?? 0) + 1;
          appliedFlag = true;
          break;
        } else {
          matchItems.push(orderItem);
          matchQuantity += orderItem.count ?? 0;
        }
      }
    }

    if (!appliedFlag && matchQuantity >= promotion.get_quantity) {
      // Apply promotion for matchItems
      let getQuantity = promotion.get_quantity;
      for (const matchItem of matchItems) {
        const matchQuantity = matchItem.count ?? 0;
        if (getQuantity >= matchQuantity) {
          getQuantity -= matchQuantity;
          matchItem.IsPromotion = true;
          matchItem.promotion_id = promotion.id;
          matchItem.promotion_name = promotion.name;
        } else {
          // split item
          const cloneItem = cloneDeep(matchItem);
          cloneItem.id = newId();
          matchItem.count = (matchItem.count ?? 0) - getQuantity;
          cloneItem.count = getQuantity;
          cloneItem.IsPromotion = true;
          cloneItem.promotion_id = promotion.id;
          cloneItem.promotion_name = promotion.name;
          orderItems.push(cloneItem);
          getQuantity = 0;
        }

        if (getQuantity === 0) {
          promotion.applied_count = (promotion.applied_count ?? 0) + 1;
          break;
        }
      }
    }
  }
}
